import { actionCopyDa } from "./actionCopy";
import { listCopyDa } from "./listCopy";

export const studiesCopyDa = {
    studies: "Studier",
    description: "Opret studier og inviter behandlere med adgang til labels, formularer, skabeloner og fakturering.",
    unauthorizedMessage: "Studier er kun tilgængelige for administratorer og managere.",
    searchPlaceholder: "Søg studier, labels, formularer eller skabeloner",
    searchAriaLabel: "Søg studier",
    clearSearchAria: actionCopyDa.clearSearch,
    filterStudiesAria: "Filtrer studier",
    studyFilterDescription: "Filtrer studier efter status og faktureringsplan.",
    newStudy: "Nyt studie",
    noStudiesYet: "Ingen studier endnu. Opret dit første studie for at konfigurere adgang og invitationer.",
    noStudiesMatchSearch: "Ingen studier matcher din søgning eller dine filtre.",
    columnStudyName: "Studienavn",
    columnLabel: "Label",
    columnForms: "Formularer",
    columnTemplates: "Skabeloner",
    columnPlan: "Plan",
    columnExpiry: "Udløb",
    columnDiaries: "Dagbøger",
    columnClinicians: "Behandlere",
    columnStatus: listCopyDa.status,
    columnActions: listCopyDa.actions,
    published: listCopyDa.published,
    draft: listCopyDa.draft,
    open: actionCopyDa.open,
    invite: actionCopyDa.invite,
    edit: actionCopyDa.edit,
    openStudyAria: "Åbn studie",
    inviteStudyAria: "Inviter behandlere til dette studie",
    editStudyAria: "Rediger studie",
    openTrackingAria: "Åbn studieprogres og diagrammer",
    trackingDialogTitle: (studyName: string) => `Fremgang · ${studyName}`,
    emptyLabel: " - ",
    templateCount: (count: number) => `${count} skabelon${count === 1 ? "" : "er"}`,
    newStudyTitle: "Nyt studie",
    newStudyDescription:
        "Konfigurer adgang til labels, formularer og skabeloner, fakturering og synlighed for managere.",
    editStudyTitle: "Rediger studie",
    editStudyDescription: "Opdater adgang til labels, formularer og skabeloner, fakturering og synlighed for managere.",
    studySaved: "Studie gemt",
    failedToSaveStudy: "Studiet kunne ikke gemmes",
    saveStudy: "Gem studie",
    saveChanges: "Gem ændringer",
    studyName: "Studienavn",
    studyNamePlaceholder: "f.eks. Elite Tendon Knee 2026",
    labelAccess: "Label-adgang",
    selectLabels: "Vælg labels",
    addLabel: "Tilføj label",
    labelName: "Labelnavn",
    labelNamePlaceholder: "f.eks. Elite Tendon Knee",
    formAccess: "Formularadgang",
    selectForms: "Vælg formularer",
    templates: "Skabeloner",
    inferredAccessTitle: "Adgang fra skabeloner",
    inferredAccessDescription: "Spørgeskemaer, tidsplaner og hændelser fra de valgte skabeloner tildeles automatisk.",
    inferredAccessEmpty: "Vælg en eller flere skabeloner for at udlede adgang.",
    inferredEvents: "Hændelser",
    inferredForms: "Spørgeskemaer",
    inferredSchedules: "Tidsplaner",
    inferredNone: "Ingen",
    customiseAccessTitle: "Tilpas adgang",
    customiseAccessHideTitle: "Skjul adgangsmuligheder",
    customiseAccessDescription:
        "Fuld kontrol over tilstande og private tildelinger. Skabelonpåkrævede spørgeskemaer, tidsplaner og hændelser forbliver valgt.",
    loadingAccessOptions: "Indlæser adgangsmuligheder…",
    billingPlan: "Faktureringsplan",
    selectPlan: "Vælg plan",
    expiryDate: "Udløbsdato",
    pickDate: "DD/MM/ÅÅÅÅ",
    expiryDateMinMessage: "Udløbsdatoen skal være i morgen eller senere",
    expiryDateMaxMessage: "Hold dig inden for de næste 100 år",
    expiryDateInvalidMessage: "Den dato ser ikke rigtig ud",
    publishStudyForManagers: "Publicer studie",
    labelAccessSummary: "Label-adgang",
    formAccessSummary: "Formularadgang",
    templatesSummary: "Skabeloner",
    billingPlanSummary: "Faktureringsplan",
    expirySummary: "Udløb",
    statusSummary: "Status",
    loadingStudy: "Indlæser studie…",
    studyNotFound: "Studie ikke fundet",
    backToStudies: "Tilbage til studier",
    studyInvite: "Studieinvitation",
    inviteToStudy: (studyName: string) => `Inviter til studiet ${studyName}`,
    inviteToStudyDescription:
        "Del en QR-kode eller et link, så behandlere kan tilmelde sig og deltage i studiet. Organisation og speciale er valgfrit.",
    inviteStepReview: "Gennemgå",
    inviteStepEmail: "E-mail",
    inviteStepQr: "QR",
    inviteStepInvite: "Inviter",
    generatingInviteLink: "Opretter invitationslink…",
    failedToCreateInviteLink: "Invitationslink kunne ikke oprettes",
    studyInviteQrDescription: (studyName: string) =>
        `Del en QR-kode eller et link, så behandlere kan tilmelde sig og deltage i ${studyName}. Organisation og speciale kommer fra studiets standarder.`,
    joinStudyTitle: (studyName: string) => `Deltag i ${studyName}`,
    optionalOrganisationSignupHint:
        "Valgfrit. Lad feltet være tomt, hvis behandleren skal oprette sin egen organisation under onboarding.",
    clinicianWillChooseOrganisation: "Behandleren vælger eller opretter sin organisation ved tilmelding.",
    specialty: "Speciale",
    optionalSuffix: "(valgfrit)",
    optionalSpecialtySignupHint:
        "Valgfrit. Når det er sat, anvendes specialet på behandlere, der tilmelder sig studiet.",
    selectSpecialtyPlaceholder: "Vælg speciale",
    clearSpecialty: "Ryd",
    clinicianInviteDefaultsTitle: "Standarder for behandlerinvitation",
    clinicianInviteDefaultsDescription:
        "Valgfrit: fastsæt organisation og speciale for behandlere, der tilmelder sig via QR eller invitationslink.",
    defaultOrganisation: "Organisation",
    noOrganisationsAvailable: "Ingen organisationer at vælge imellem.",
    inviteDefaultsSummary: (summary: string) => `Invitationsstandarder: ${summary}`,
    inviteDefaultsEmpty:
        "Ingen organisation eller speciale er sat på studiet. Behandlere vælger dette under onboarding.",
    emailRequired: "E-mailadresse er påkrævet",
    validEmailRequired: "Indtast en gyldig e-mailadresse",
    studyInviteEmailSent: "Studieinvitation sendt via e-mail",
    failedToSendInvite: "Invitationen kunne ikke sendes",
    trackingTitle: "Studiestyring",
    trackingDescription: "Behandlere med studiets labels og de dagbøger, de har oprettet.",
    trackingLabelsHint: "Labels",
    trackingLoading: "Indlæser tracking…",
    trackingError: "Studiestyring kunne ikke indlæses.",
    trackingNoLabels: "Tilføj labels til studiet for at tracke behandlere og dagbøger.",
    trackingNoClinicians: "Ingen behandlere har disse labels endnu.",
    trackingNoDiaries: "Ingen dagbøger er mærket til dette studie endnu.",
    trackingCliniciansWithAccess: "Behandlere med adgang",
    trackingCliniciansHint: (members: number, withLabels: number) =>
        `${members} studiemedlem${members === 1 ? "" : "mer"} · ${withLabels} med labeladgang`,
    trackingTotalDiaries: "Dagbøger",
    trackingAvgDiariesPerClinician: "Gns. dagbøger / behandler",
    trackingCliniciansWithDiaries: "Behandlere med dagbøger",
    trackingDiariesPerClinician: "Dagbøger pr. behandler",
    trackingCumulativeDiaries: "Kumulerede dagbøger",
    trackingClinicianTableTitle: "Behandlere",
    trackingColumnClinician: "Behandler",
    trackingColumnDiaries: "Dagbøger",
    trackingColumnAccess: "Adgang",
    trackingAccessMember: "Studiemedlem",
    trackingAccessLabel: "Labeladgang",
    trackingAccessDiaryOnly: "Kun dagbøger",
    trackingCliniciansShort: "behandlere",
    trackingNoLabelsShort: "Ingen labels",
    trackingNoDiariesShort: "Ingen dagbøger endnu",
};
